import React from "react";
import SiteLayout from "../src/components/layouts/SiteLayout";
import PageHeading from "@Components/PageHeading";

import { Typography, Button, Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  divider: {
    marginBottom: theme.spacing(2),
  },
  root: {
    maxWidth: 375,
    padding: theme.spacing(1, 2, 1),
    marginTop: theme.spacing(5),
  },
  title: {
    // fontStyle: "normal",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  address: {
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 150,
  },
}));

const ContactPage = () => {
  const classes = useStyles();
  return (
    <SiteLayout>
      <PageHeading text="Get in touch"></PageHeading>
      <Grid container spacing={3}>
        <Grid item xs>
          <Paper className={classes.paper}>
            <Typography variant="h5" gutterBottom className={classes.title}>
              Address
            </Typography>
            <Typography variant="body2" component="span" display="block">
              P.O. Box 2267
            </Typography>
            <Typography
              variant="body2"
              component="span"
              display="block"
              gutterBottom
            >
              Bonita Springs, Florida 34133
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs>
          <Paper className={classes.paper}>
            <Typography variant="h5" gutterBottom className={classes.title}>
              Email
            </Typography>
            <Typography
              variant="body2"
              component="span"
              display="block"
              gutterBottom
            >
              <a href="mailto:support@traceamerica.com">
                <Button variant="text" color="primary">
                  support@traceamerica.com
                </Button>
              </a>
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs>
          <Paper className={classes.paper}>
            <Typography variant="h5" gutterBottom className={classes.title}>
              Phone
            </Typography>
            <Typography
              variant="body2"
              component="span"
              display="block"
              gutterBottom
            >
              <a href="tel:800-827-1834">
                <Button variant="text" color="primary">
                  1-800-827-1834
                </Button>
              </a>
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </SiteLayout>
  );
};

export default ContactPage;
